import { createAction } from '@reduxjs/toolkit';

export const getUserInfo = createAction('auth/getUserInfo');
